import { Switch as HeadlessSwitch, SwitchProps } from "@headlessui/react";
import cx from "classnames";
import { Fragment } from "react";

interface SwitchComponentProps
  extends Pick<
    SwitchProps<typeof Fragment>,
    "onChange" | "checked" | "defaultChecked"
  > {
  id?: string;
  label: string;
  disabled?: boolean;
  "data-testid"?: string;
}

export function Switch({
  id,
  onChange,
  checked,
  defaultChecked,
  label,
  disabled = false,
  "data-testid": testId,
}: SwitchComponentProps) {
  return (
    <HeadlessSwitch
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={onChange}
      disabled={disabled}
      as={Fragment}
    >
      {({ checked }) => (
        <button
          id={id}
          aria-label={label}
          disabled={disabled}
          data-testid={testId}
          className={cx(
            `relative inline-flex h-5 w-8 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`,
            {
              "bg-blue-600": checked,
              "bg-gray-400": !checked,
              "cursor-pointer": !disabled,
              "opacity-50 cursor-not-allowed": disabled,
            }
          )}
        >
          <span
            aria-hidden="true"
            className={cx(
              `pointer-events-none inline-block size-4 rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`,
              {
                "translate-x-3 bg-white": checked,
                "translate-x-[0.0375em] bg-gray-700": !checked,
              }
            )}
          />
        </button>
      )}
    </HeadlessSwitch>
  );
}
